import { Circle, CheckCircle2, MessageSquare } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

/**
 * Shared checklist-style row used by the driver readiness checklist and the
 * unified BOL/Notes block on the driver assignment detail page.
 */
export function ChecklistRow({
  complete,
  optional,
  label,
  viewCount = 0,
  onClick,
  onViewClick,
  trailing,
  leadingIcon,
}: {
  complete: boolean;
  optional?: boolean;
  label: string;
  viewCount?: number;
  onClick: () => void;
  onViewClick?: () => void;
  trailing: React.ReactNode;
  /** Override the leading icon (defaults: check when complete, message when optional, circle otherwise). */
  leadingIcon?: React.ReactNode;
}) {
  const leading =
    leadingIcon ??
    (complete ? (
      <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
    ) : optional ? (
      <MessageSquare className="h-5 w-5 shrink-0 text-muted-foreground" />
    ) : (
      <Circle className="h-5 w-5 shrink-0 text-muted-foreground" />
    ));

  return (
    <div className="flex items-center gap-3 px-3 py-3">
      {leading}
      <button
        type="button"
        onClick={onClick}
        className="flex-1 text-left text-sm font-medium"
      >
        {label}
      </button>
      {viewCount > 0 && onViewClick && (
        <Badge
          variant="secondary"
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            onViewClick();
          }}
        >
          View {viewCount}
        </Badge>
      )}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0"
        onClick={onClick}
      >
        {trailing}
      </Button>
    </div>
  );
}